module.exports = "../dist/frontend/icons/letters/a-green.svg?07b1cbcd3d9bb2a8fd7f120f2a0e5354";